module.exports = __webpack_public_path__ + "static/media/institution.1aeec2d3.svg";